// src/constant/key.ts
class Keys {
    static languageKey = 'vue3-typescript-admin-languageKey'
  }
     
  export default Keys
  